export default {
  // Navigation
  "home": "الرئيسية",
  "services": "الخدمات",
  "solutions": "الحلول",
  "about": "من نحن",
  "onlineStore": "المتجر الإلكتروني",
  "contact": "اتصل بنا",
  
  // Hero Section
  "hero.title": "حلول تشطيب وديكور",
  "hero.titleHighlight": "متميزة",
  "hero.subtitle": "خدمات إنشاءات شاملة من الألف إلى الياء في المملكة العربية السعودية - الكهرباء، الشبكات، أنظمة التكييف، اللافتات الرقمية، الحلول الصوتية والمرئية وأكثر",
  "hero.ourSolutions": "حلولنا",
  "hero.getFreeQuote": "احصل على عرض مجاني",
  
  // Services Section
  "services.title": "خدماتنا",
  "services.titleHighlight": "المتميزة",
  "services.subtitle": "نقدم خدمات إنشاءات وتشطيب شاملة مصممة لتلبية متطلباتكم الخاصة بأعلى معايير الجودة.",
  "services.electrical.title": "الأنظمة الكهربائية",
  "services.electrical.description": "تركيب وصيانة وأتمتة الأنظمة الكهربائية الكاملة للممتلكات السكنية والتجارية.",
  "services.networking.title": "حلول الشبكات",
  "services.networking.description": "البنية التحتية المتقدمة لتقنية المعلومات والألياف البصرية وحلول الاتصال الذكي للشركات الحديثة.",
  "services.hvac.title": "أنظمة التكييف",
  "services.hvac.description": "أنظمة تدفئة وتهوية وتكييف موفرة للطاقة مع تحكم ذكي في المناخ.",
  "services.digitalsignage.title": "اللافتات الرقمية",
  "services.digitalsignage.description": "شاشات تفاعلية وشاشات LED وحلول إعلانية رقمية لأقصى تأثير.",
  "services.audiovisual.title": "الصوت والصورة",
  "services.audiovisual.description": "أنظمة صوتية احترافية ومؤتمرات فيديو وحلول وسائط متعددة لأي مساحة.",
  "services.construction.title": "التشطيب الكامل",
  "services.construction.description": "خدمات إنشاءات وتشطيب داخلي شاملة من التصميم إلى اللمسة الأخيرة.",
  
  // Solutions Section
  "solutions.title": "حلول",
  "solutions.titleHighlight": "مخصصة",
  "solutions.subtitle": "من المفهوم إلى الإنجاز، نقدم حلولاً مبتكرة تحول المساحات وتتجاوز التوقعات.",
  "solutions.residential.title": "المشاريع السكنية",
  "solutions.residential.description": "أتمتة منزلية فاخرة وإضاءة ذكية وتحكم في المناخ وخدمات تشطيب داخلي متميزة.",
  "solutions.commercial.title": "المساحات التجارية",
  "solutions.commercial.description": "المباني المكتبية والمساحات التجارية والمطاعم وأماكن الضيافة بالبنية التحتية الحديثة.",
  "solutions.industrial.title": "المرافق الصناعية",
  "solutions.industrial.description": "مصانع التصنيع والمستودعات والمرافق المتخصصة بأنظمة كهربائية وميكانيكية قوية.",
  "solutions.healthcare.title": "المرافق الصحية",
  "solutions.healthcare.description": "المستشفيات والعيادات والمراكز الطبية بأنظمة كهربائية متخصصة وأنظمة سلامة الحياة.",
  
  // About Section
  "about.title": "لماذا تختار",
  "about.titleHighlight": "المخطط؟",
  "about.subtitle": "بسنوات من الخبرة في السوق السعودي، نحقق التميز في كل مشروع نتولاه.",
  "about.experience.title": "+15 سنة خبرة",
  "about.experience.description": "سجل حافل في مشاريع الإنشاءات والتشطيب في جميع أنحاء المملكة العربية السعودية.",
  "about.certified.title": "محترفون معتمدون",
  "about.certified.description": "مهندسون وفنيون مرخصون يضمنون أعلى معايير الجودة.",
  "about.support.title": "دعم 24/7",
  "support.description": "خدمات صيانة ودعم طوارئ على مدار الساعة.",
  "about.warranty.title": "ضمان شامل",
  "about.warranty.description": "تغطية ضمان ممتدة على جميع التركيبات والمعدات.",
  
  // Contact Section
  "contact.title": "تواصل",
  "contact.titleHighlight": "معنا",
  "contact.subtitle": "مستعد لتحويل مساحتك؟ اتصل بنا اليوم للحصول على استشارة وعرض سعر مجاني. فريقنا هنا لتحقيق رؤيتك.",
  "contact.information": "معلومات الاتصال",
  "contact.phone": "الهاتف",
  "contact.email": "البريد الإلكتروني",
  "contact.office": "المكتب",
  "contact.workingHours": "ساعات العمل",
  "contact.workingHours.weekdays": "الأحد - الخميس: 8:00 ص - 6:00 م",
  "contact.workingHours.weekend": "الجمعة - السبت: طوارئ فقط",
  "contact.findUs": "اعثر علينا",
  "contact.form.title": "طلب عرض سعر",
  "contact.form.name": "الاسم الكامل",  
  "contact.form.email": "عنوان البريد الإلكتروني",
  "contact.form.phone": "رقم الهاتف",
  "contact.form.company": "الشركة",
  "contact.form.service": "الخدمة المطلوبة",
  "contact.form.message": "تفاصيل المشروع",
  "contact.form.namePlaceholder": "اسمك الكامل",
  "contact.form.emailPlaceholder": "your.email@almukhatat.sa",
  "contact.form.phonePlaceholder": "+966 55 642 1472",
  "contact.form.companyPlaceholder": "اسم شركتك",
  "contact.form.messagePlaceholder": "أخبرنا عن متطلبات مشروعك والجدول الزمني وأي احتياجات خاصة...",
  "contact.form.selectService": "اختر خدمة",
  "contact.form.electrical": "الأنظمة الكهربائية",
  "contact.form.networking": "حلول الشبكات",
  "contact.form.hvac": "أنظمة التكييف",
  "contact.form.digitalSignage": "اللافتات الرقمية",
  "contact.form.audioVisual": "الصوت والصورة",
  "contact.form.completeFitout": "التشطيب الكامل",
  "contact.form.multiple": "خدمات متعددة",
  "contact.form.send": "إرسال الرسالة",
  "contact.form.sending": "جاري الإرسال...",
  "contact.form.success": "شكراً لك! تم إرسال رسالتك بنجاح. سنتواصل معك خلال 24 ساعة.",
  "contact.form.error": "يرجى ملء جميع الحقول المطلوبة بشكل صحيح والتأكد من أن رسالتك أقل من 500 حرف.",
  "contact.form.charactersLeft": "حرف",
  "contact.form.required": "*",
  
  // Footer
  "footer.description": "شركة رائدة في الإنشاءات والتشطيب في المملكة العربية السعودية، متخصصة في الأنظمة الكهربائية والشبكات والتكييف والحلول الداخلية الكاملة.",
  "footer.quickLinks": "روابط سريعة",
  "footer.services.title": "الخدمات",
  "footer.contact.title": "معلومات الاتصال",
  "footer.contact.address": "طريق سلمان الفارسي، حي النهضة، الرياض، المملكة العربية السعودية",
  "footer.followUs": "تابعنا",
  "footer.copyright": "© 2026 المخطط. جميع الحقوق محفوظة.",
  
  // Common
  "learnMore": "اعرف المزيد",
  "getStarted": "ابدأ الآن",
  "readMore": "اقرأ المزيد",
  "viewAll": "عرض الكل"
}